import { ApplicationWithDetails } from '../../../types';
import { BrandPanelDetails_eng } from './BrandPanelDetails/BrandPanelDetails_eng';
import { BrandPanelInstructions_eng } from './BrandPanelInstructions/BrandsPanelInstructions_eng';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const BrandPanel_eng: ApplicationWithDetails = {
	id: `11ECF3AAF97D059CB9706F21406EBF22`,
	name: `Brands Digital Dashboard`,
	description: `Digital dashboard with revenue of all Dodo\xa0Brands.`,
	descriptionLong: `We accepted 5 new orders while you were reading this!\n\nOpenness is a key value of our company. We openly show the revenue, number of restaurants and countries and other important metrics of the entire Dodo Brands network. Lights are constantly flickering on the interactive map — these are new orders made all over the world in real time. As the classic said, there are 3 things you can watch forever: how fire burns, how water flows and how Dodo customers make new orders.`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/digitalbp/logo-n`,
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/digitalbp/bgr`,
	sliders: [
		`https://cdn.dodostatic.net/static/marketplace/digitalbp/slider1`,
		`https://cdn.dodostatic.net/static/marketplace/digitalbp/slider2`,
		`https://cdn.dodostatic.net/static/marketplace/digitalbp/slider3`,
	],
	// eslint-disable-next-line sonarjs/no-duplicate-string
	webSiteUrl: ``,
	supportUrl: `https://realtime.dodobrands.io/?source=marketplace`,
	redirectUrl: `https://realtime.dodobrands.io/?source=marketplace`,
	contactEmail: `support@dodopizza.com`,
	supportEmail: ``,
	categories: [`Office`],
	countries: [`All`],
	languages: [`English`],
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	price: `Free`,
	type: `TV-Board`,
	version: `1.0`,
	developer: `Dodo Brands`,
	plans: null,
	instructions: BrandPanelInstructions_eng,
	details: BrandPanelDetails_eng,
	knowledgeBase: null,
	isExternal: false,
	showInstruction: false,
	versionHistory: null,
	goToApp: true,
	isFreeForAllRoles: true,
	isOpenForUnauthorized: true,
};
